import { useRegistrSVDetailContext } from '@gov-nx/module/page';
import { DataTable, InfoTooltip } from '@gov-nx/ui/web';
import { toDateReadable } from '@gov-nx/utils/common';

interface TableRelationshipToTheVehicleProps {
	tsn: (code: string) => string;
}

export const TableRelationshipToTheVehicle = ({
	tsn,
}: TableRelationshipToTheVehicleProps) => {
	const { relationshipsToTheVehicle, previousOwners, previousKeepers } =
		useRegistrSVDetailContext();

	return (
		<DataTable responsive>
			<tbody>
				<tr>
					<td className="sm:w-1/2">
						{tsn('formular.filtr.detail-vztah-k-vozidlu')}
					</td>
					<td className="sm:w-1/2">
						{relationshipsToTheVehicle.map((vztah) => (
							<>
								<strong
									key={`${vztah.vztah}-${vztah.od}`}
									className="w-full">{`${tsn(vztah.vztah)} ${tsn(
									'formular.label.obdobi-od'
								).toLowerCase()} ${
									vztah.od && toDateReadable(vztah.od)
								}`}</strong>
								<br />
							</>
						))}
					</td>
				</tr>
				<tr>
					<td className="sm:w-1/2">
						{tsn('formular.label.pocet-predchozich-vlastniku')}
					</td>
					<td className="sm:w-1/2">
						<strong>{previousOwners}</strong>
					</td>
				</tr>
				<tr>
					<td className="sm:w-1/2">
						{tsn('formular.label.pocet-predchozich-provozovatelu')}
						<InfoTooltip
							content={tsn(
								'formular.label.pocet-predchozich-provozovatelu-tooltip'
							)}
						/>
					</td>
					<td className="sm:w-1/2">
						<strong>{previousKeepers}</strong>
					</td>
				</tr>
			</tbody>
		</DataTable>
	);
};
